export enum MessageLevel {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Danger = 'danger',
}
